module.exports = __webpack_public_path__ + "static/media/hvb_logo.bf3be002.png";